import { render, staticRenderFns } from "./notification-center.vue?vue&type=template&id=3dfe7618&"
import script from "./notification-center.vue?vue&type=script&lang=js&"
export * from "./notification-center.vue?vue&type=script&lang=js&"
import style0 from "./notification-center.vue?vue&type=style&index=0&id=3dfe7618&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports